/*
 * jdgm-rating-format.js
 * Normalizes the Judge.me average-rating NUMBER shown to visitors:
 * strips trailing decimal zeros so "5.00" -> "5", "4.50" -> "4.5"
 * (e.g. the homepage badge "5.00 von 5" becomes "5 von 5").
 *
 * Why JS: the rating is rendered by the Judge.me app (cards_carousel /
 * preview badge), not by theme Liquid, so it cannot be changed in the theme
 * files. This runs on ALL storefront locales (unlike jdgm-auto-translate.js,
 * which only runs on en/ar). It is strictly scoped to Judge.me rating
 * elements, so prices and other numbers are never touched.
 */
(function () {
  // Containers whose text/aria holds a Judge.me rating number.
  var SELECTORS = [
    '.jdgm-rating-text',
    '.jdgm-prev-badge',
    '.jdgm-prev-badge__text',
    '.jdgm-histogram__average',
    '.jdgm--average',
    '.jdgm-rev-widg__summary-average',
    '.jdgm-all-reviews-rating',
    '.jdgm-stars'
  ].join(',');

  var DEC = /\d+\.\d{1,2}/g; // a rating-style decimal, e.g. 5.00 or 4.83
  function strip(m) { return String(parseFloat(m)); } // 5.00 -> "5", 4.50 -> "4.5"

  function fixEl(el) {
    // 1) own aria-label (e.g. "5.00 out of 5 stars")
    var al = el.getAttribute && el.getAttribute('aria-label');
    if (al && DEC.test(al)) { DEC.lastIndex = 0; el.setAttribute('aria-label', al.replace(DEC, strip)); }
    DEC.lastIndex = 0;
    // 2) visible text nodes
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node, edits = [];
    while ((node = walker.nextNode())) {
      DEC.lastIndex = 0;
      if (DEC.test(node.nodeValue)) edits.push(node);
    }
    edits.forEach(function (n) { DEC.lastIndex = 0; n.nodeValue = n.nodeValue.replace(DEC, strip); });
    // 3) descendant aria-labels
    if (el.querySelectorAll) {
      el.querySelectorAll('[aria-label]').forEach(function (s) {
        var a = s.getAttribute('aria-label');
        DEC.lastIndex = 0;
        if (a && DEC.test(a)) { DEC.lastIndex = 0; s.setAttribute('aria-label', a.replace(DEC, strip)); }
      });
    }
  }

  var observer = null;
  function run() {
    if (observer) observer.disconnect();
    try {
      document.querySelectorAll(SELECTORS).forEach(fixEl);
    } finally {
      if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  function start() {
    run();
    observer = new MutationObserver(function () {
      // debounce a touch; Judge.me re-renders in bursts
      window.clearTimeout(start._t);
      start._t = window.setTimeout(run, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    // fallbacks for late async widget loads
    [500, 1500, 3000].forEach(function (ms) { window.setTimeout(run, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
